import "core-js/modules/es6.array.find-index";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import "core-js/modules/es6.regexp.match";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

var _dec, _class, _class2, _temp;

/* eslint-disable react/jsx-no-bind */
import React, { Component, Suspense as _Suspense } from 'react';
import PropTypes from 'prop-types';
import { match, matchMany, replace, push, pop } from '@rexlabs/whereabouts';
import { autobind } from 'core-decorators';
import { withWhereabouts } from './connectors';
import invariant from 'invariant';
import warning from 'warning';
import { __DEV__ } from './utils/env';
var RenderMatchedRoutes = (_dec = withWhereabouts(), _dec(_class = autobind(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  _inherits(RenderMatchedRoutes, _Component);

  function RenderMatchedRoutes() {
    _classCallCheck(this, RenderMatchedRoutes);

    return _possibleConstructorReturn(this, _getPrototypeOf(RenderMatchedRoutes).apply(this, arguments));
  }

  _createClass(RenderMatchedRoutes, [{
    key: "Suspense",
    value: function Suspense(_ref) {
      var _this = this;

      var match = _ref.match,
          whereabouts = _ref.whereabouts,
          matchedRoutes = _ref.matchedRoutes,
          index = _ref.index,
          Child = _ref.Child,
          props = _objectWithoutProperties(_ref, ["match", "whereabouts", "matchedRoutes", "index", "Child"]);

      return React.createElement(_Suspense, props, React.createElement(Child, _extends({}, props, {
        key: match.key,
        match: match,
        whereabouts: whereabouts,
        closeModal: function closeModal() {
          return _this.closeModal(matchedRoutes[index - 1]);
        } // For unit tests we want to be able to access the
        // key prop value!

      }, __DEV__ ? {
        devKey: match.key
      } : {})));
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      // Only rerender if any of the relevant props changed!
      if (this.props.routes === nextProps.routes && this.props.whereabouts === nextProps.whereabouts && this.props.location === nextProps.location) {
        return false;
      }

      return true;
    } // Simply runs `matchMany` on the given routes object, which will (hopefully)
    // return an array we can use for rendering the routes!

  }, {
    key: "getMatchedRoutes",
    value: function getMatchedRoutes() {
      var _this$props = this.props,
          routes = _this$props.routes,
          location = _this$props.location,
          whereabouts = _this$props.whereabouts;
      return matchMany(location || whereabouts, routes);
    } // Close the modal by either pushing a new location to the parent match route
    // or simply poping the history if the last location was the parent match
    // NOTE: this is very opinionated and needs to be discussed to make sure we
    // implement the most intuitive behaviour!

  }, {
    key: "closeModal",
    value: function closeModal(parentMatch) {
      var whereabouts = this.props.whereabouts;

      if (!parentMatch) {
        return;
      }

      var currIndex = whereabouts.history.findIndex(function (entry) {
        return entry.id === whereabouts.id;
      });
      var prevLocation = whereabouts.history[currIndex - 1];

      try {
        if (prevLocation && match(prevLocation, parentMatch.route)) {
          pop();
        } else {
          push({
            config: parentMatch.route
          }, {
            params: parentMatch.params
          });
        }
      } catch (e) {
        warning(!e, 'Something went wrong during pop attempt! Pushing new route instead!');
        push({
          config: parentMatch.route
        }, {
          params: parentMatch.params
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          whereabouts = _this$props2.whereabouts,
          routes = _this$props2.routes,
          location = _this$props2.location,
          NotFound = _this$props2.NotFound,
          fallback = _this$props2.fallback,
          children = _this$props2.children;
      var matches = null; // Find matches and render them looping through the match array

      var matchedRoutes = this.getMatchedRoutes();

      if (matchedRoutes && matchedRoutes.length) {
        matches = matchedRoutes.map(function (match, i) {
          var Component = match.route.Component;

          if (match.route.redirect) {
            // Redirect can be defined as function that returns an object
            // or as an object directly. If the function return falsy,
            // there will be no redirect (to allow e.g. conditional redirects)
            var target = null;

            if (typeof match.route.redirect === 'function') {
              target = match.route.redirect(whereabouts);
            } else {
              target = match.route.redirect;
            }

            if (target) {
              replace({
                config: target
              });
              return null;
            }
          }

          invariant(Component, "No component found to be rendered for route '".concat(match.key, "'!"));

          if (!_Suspense) {
            return component;
          }

          return React.createElement(_this2.Suspense, _extends({
            key: match.key
          }, __DEV__ ? {
            devKey: match.key
          } : {}, {
            fallback: fallback,
            match: match,
            whereabouts: whereabouts,
            matchedRoutes: matchedRoutes,
            index: i,
            Child: Component
          }));
        }); // NOTE: since we're not on React 16 yet, we cannot return an array from
        // the render function, so we have to wrap the screens in a div here :(
        // This means this becomes a problem when dealing with animation groups,
        // so we allow functional children to deal with that

        if (typeof children === 'function') {
          return children(matches);
        }

        return React.createElement("div", null, matches);
      }

      matches = NotFound ? React.createElement(NotFound, {
        routes: routes,
        location: location || whereabouts
      }) : null;

      if (typeof children === 'function') {
        return children(matches);
      }

      return matches;
    }
  }]);

  return RenderMatchedRoutes;
}(Component), _defineProperty(_class2, "defaultProps", {
  fallback: null
}), _temp)) || _class) || _class);
RenderMatchedRoutes.propTypes = process.env.NODE_ENV !== "production" ? {
  routes: PropTypes.object.isRequired,
  location: PropTypes.object,
  NotFound: PropTypes.oneOfType([PropTypes.func]),
  Fallback: PropTypes.element,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.func])
} : {};
export default RenderMatchedRoutes;